<template>
  <b-modal
    :id="id"
    hide-footer
    centered
    title="Request Reset Password"
    @hidden="resetModal"
    @shown="onShown"
  >
    <ValidationObserver v-slot="{ invalid }" ref="form">
      <b-form @submit.prevent="handleSubmit">
        <p class="mb-1 ml-1 font-weight-500">Username</p>
        <div class="input-group mb-2">
          <input
            id="email-input"
            type="text"
            class="form-control"
            placeholder="username"
            v-model="editFormData.username"
          />
        </div>

        
        <div class="modalBtns mt-3">
          <b-button
            type="submit"
            variant="light"
            class="px-4 py-1"
            id="modalSubmitBtn"
            :disabled="invalid || isSubmitting"
            >Reset Password</b-button
          >
          <b-button
            @click="$bvModal.hide(id)"
            variant="light"
            class="px-4 py-1"
            id="modalCancelBtn"
          >
            Cancel
          </b-button>
        </div>
      </b-form>
    </ValidationObserver>
    <!-- <MessageModal
      :id="`cancelRescheduleMsgModal`"
      :title="cancelRescheduledMsgTitle"
      :body="cancelRescheduledMsgBody"
    /> -->
  </b-modal>
</template>
<script>
import MessageModal from "@/portal/components/common/messageModal.vue";
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import moment from "moment";
import { WeekDay } from "@/entities/options";
import meUtil from "@/utils/me";
import passportApi from "@/apis/passport/index";

const formData = {
  username: ""
};

export default {
  name: "resetpassword",
  components: {
    MessageModal,
  },
  // :preventSameClass="true"
  props: {
    id: {
      type: String,
      default: "resetPasswordRequestModal",
      require: false,
    },
  },
  data() {
    return {
      me: null,
      editFormData: {
        ...formData,
      },
      loadingCount: 0,
      isSubmitting: false,
      resetPasswordMsgTitle: "",
      resetPasswordMsgBody: "Password Link sent!",
    };
  },
  mounted() {
    this.me = meUtil.get();
  },
  methods: {
    async onShown() {
      
    },


    handleSubmit() {
      this.isSubmitting = true
      passportApi
        .sendResetPasswordLink(this.editFormData.username)
        .then((response) => {
          this.$dialog.alert("A reset password link has been sent to your email.", {
            customClass: "dialog-alert",
          });
          let that = this;

          setTimeout(function () {
            that.$root.$emit("bv::hide::modal", this.id);
          }, 2000);
        })
        .catch((error) => {
          this.$dialog.alert(error.response.data, {
            customClass: "dialog-alert",
          });
        })
        .finally(() => {
          this.isSubmitting = false;
        });
      // overviewApi.removeRescheduledLesson(this.lesson.id).then((result) => {

      // })
      // .catch((error) => {
      //   console.warn(error);
      //   let message = "Save failed.";
      //   if (error.response.data.message) {
      //     message = error.response.data.message;
      //   }
      //   this.$dialog.alert(message, {
      //     customClass: "dialog-alert",
      //   });
      // })
      // .finally(() => {
      //   this.loadingCount = 0;
      //   this.isSubmitting = false;
      // });
    },
    resetModal() {
      this.editFormData = {
        ...formData,
      };
      this.$emit("modalClosed");
    },
  },
};

extend("required", {
  ...required,
  message: "The {_field_} is required",
});
</script>
